import { OrderStatus } from "../types/orderStatus";
import { GlobalStore } from "../store/global/GlobalStore";
import { useCallback, useState } from "react";
import { useIdleTimer } from "react-idle-timer";
import { NATIVE_TOKEN_ADDRESS, TIME_BEFORE_USER_IS_IDLE } from "../config/consts";
import { getWrappedTokenAddress } from "../utils/chainUtils";
import { getSelectedTokenSymbolArray } from "../utils/quoteUtils";
import { isAddressEqual } from "../utils/tokenUtils";

export const useCanQuote = (): boolean => {
  const { makerTokens, takerTokens, orderStatus, network } = GlobalStore.useState(s => {
    return {
      makerTokens: s.makerTokens,
      takerTokens: s.takerTokens,
      orderStatus: s.orderStatus,
      network: s.network,
    };
  });
  const [isUserIdle, setIsUserIdle] = useState<boolean>(false);
  const handleOnIdle = useCallback(() => {
    setIsUserIdle(true);
    GlobalStore.update(s => {
      s.quoteExpired = true;
    });
  }, []);
  const handleOnActive = useCallback(() => {
    setIsUserIdle(false);
  }, []);
  useIdleTimer({
    timeout: TIME_BEFORE_USER_IS_IDLE,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    debounce: 500,
  });
  const takerTokenHasAnAmount = !takerTokens.some(entry => entry.amount.value.isZero());
  const makerTokensSelected = makerTokens.length > 0;
  const quotableOrderState =
    orderStatus === OrderStatus.ENTRY || orderStatus === OrderStatus.QUOTING;
  const isUnwrapping =
    getSelectedTokenSymbolArray(takerTokens).some(address =>
      isAddressEqual(address, getWrappedTokenAddress(network))
    ) &&
    getSelectedTokenSymbolArray(makerTokens).some(address =>
      isAddressEqual(address, NATIVE_TOKEN_ADDRESS)
    );
  const isWrapping =
    getSelectedTokenSymbolArray(makerTokens).some(address =>
      isAddressEqual(address, getWrappedTokenAddress(network))
    ) &&
    getSelectedTokenSymbolArray(takerTokens).some(address =>
      isAddressEqual(address, NATIVE_TOKEN_ADDRESS)
    );

  const isNotWrappingOrUnwrapping = !isWrapping && !isUnwrapping;
  const canQuote =
    takerTokenHasAnAmount && makerTokensSelected && quotableOrderState && isNotWrappingOrUnwrapping;
  return !isUserIdle && canQuote;
};
